import {
    queryClient,
    RETRY_COUNT,
    STALE_TIME_RESOURCES,
} from "@impero-com/common/utils/query_client";

import {
    getGetUserGroupsQueryOptions,
    GetUserGroupsQueryResult,
    useGetUserGroups,
} from "api/generated/user-groups/user-groups";

const userGroupsQueryConfig = {
    staleTime: STALE_TIME_RESOURCES,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    retry: RETRY_COUNT,
    select: (response: GetUserGroupsQueryResult) => {
        const data = response.data;
        if (data.type !== "WithUsers") {
            throw new Error("Expected WithUsers response type");
        }

        return data.data.content.flatMap((dto) => dto.resource);
    },
};

export function useUserGroupsQuery() {
    return useGetUserGroups(
        { format: "WithUsers" },
        { query: userGroupsQueryConfig }
    );
}
export function fetchUserGroupQuery() {
    return queryClient.fetchQuery(
        getGetUserGroupsQueryOptions({ format: "WithUsers" })
    );
}
